<div class="col-lg-12" style="background-color:white; padding: 0px 0px;">
    <div>
        <img id="LogoTag1" src="./assets/kvb_logo_long_border.jpg" style="width:100%;height: 86px;">
    </div>
</div>